import {UserService} from './../../../shared/services/user.service';
import {Customer} from './../../../shared/models/customer';
import {ArticleService} from './../../../shared/services/article.service';
import {ImageService} from '../../../shared/services/image.service';
import {Component, OnInit, OnDestroy} from '@angular/core';
import {CartItem} from '../../../shared/classes/cart-item';
import {CartService, SecureCartItem} from '../../../shared/services/cart.service';
import {Observable, of, Subscription} from 'rxjs';
import {round} from '../../../shared/utils/utils';
import {Article} from '../../../shared/models/article';

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    providers: [ImageService, ArticleService, UserService],
    standalone: false
})
export class CartComponent implements OnInit, OnDestroy {

  public cartItems: Observable<CartItem[]> = of([]);
  public shoppingCartItems:   CartItem[] = [];
  public isLoading: boolean = true;
  private cartSubscription: Subscription;
 
  constructor(
    private cartService: CartService, 
    private uploadFileService: ImageService,
    public articleService: ArticleService,
    private userService: UserService) { }

  ngOnInit() {
    this.cartSubscription = this.cartService.cartItems.subscribe((secureItems) => {
      if (!secureItems || secureItems.length === 0) {
        this.shoppingCartItems = [];
        this.isLoading = false;
        return;
      }

      // If all incoming SKUs are already loaded, just sync quantities — no API call, no spinner
      const loadedSkus = new Set(this.shoppingCartItems.map(i => i.product?.sku));
      const allAlreadyLoaded = secureItems.every(s => loadedSkus.has(s.sku));

      if (allAlreadyLoaded) {
        const qtyMap = new Map(secureItems.map(s => [s.sku, s.quantity]));
        this.shoppingCartItems = this.shoppingCartItems
          .filter(item => qtyMap.has(item.product.sku))
          .map(item => ({ ...item, quantity: qtyMap.get(item.product.sku) }));
      } else {
        this.loadCartItemsFromSecureItems(secureItems);
      }
    });
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
  }

  private loadCartItemsFromSecureItems(secureItems: SecureCartItem[]) {
    this.isLoading = true;
    this.shoppingCartItems = [];

    const skus = secureItems.map(item => item.sku);

    this.articleService.getArticlesBySku(skus).subscribe(
      (products: Article[]) => {
        this.shoppingCartItems = secureItems
          .map(secureItem => {
            const product = products.find(p => p.sku === secureItem.sku);
            if (product) {
              return { product, quantity: secureItem.quantity } as CartItem;
            }
            console.error('❌ Producto NO encontrado para SKU:', secureItem.sku);
            return null;
          })
          .filter(item => item !== null);

        this.isLoading = false;
      },
      error => {
        console.error('❌ Error loading cart products:', error);
        this.shoppingCartItems = [];
        this.isLoading = false;
      }
    );
  }

  public update(item: CartItem) {
      if (item.quantity <= 0) this.cartService.updateCartQuantity(item.product, 1);
  }

  // Increase Product Quantity
  public increment(product: any, quantity: number = 1) {
    this.cartService.updateCartQuantity(product, quantity);
  }
  
  // Decrease Product Quantity
  public decrement(product: any, quantity: number = -1) {
    this.cartService.updateCartQuantity(product, quantity);
  }
  
  // Get Total
  public getTotal(): Observable<number> {
    return this.cartService.getTotalAmount();
  }

  // Redondea valor
  roundValue = (value) => round(value);

  // Remove cart items
  public removeItem(item: CartItem) {
    this.cartService.removeFromCart(item);
  }

   getPriceProduct(item: CartItem) {   
    const c: Customer = this.userService.getIdentity();
    let price = item.product.unitPrice;
    if (c) {
      price = this.articleService.getPrice(item.product, c.listPrice);
    }
    return price;
  }

  getSubtotal(item: CartItem) {
    const price = this.getPriceProduct(item);
    return this.roundValue(price * item.quantity);
  }

  // arma url de la photo del articulo
	getUrl = (photos: string) => {        
		return this.uploadFileService.getUrlFirstElement(photos);
	}

	getPrice(p: Article) {
      const customer: Customer = this.userService.getIdentity();
      if (customer) {
        return this.articleService.getPrice(p, customer.listPrice);
      } else {
        return p.unitPrice;
      }
    }
}